export const ApprovalStatusConst = {
  PEN: {
    label: "PENDING",
    variant: "outline-secondary",
    tooltip: "Menunggu approval"
  },
  ONP: {
    label: "ON PROGRESS",
    variant: "outline-warning",
    tooltip: "Sedang dalam proses pengerjaan"
  },
  EVA: {
    label: "EVALUATION",
    variant: "outline-info",
    tooltip: "Sedang dalam proses evaluasi"
  },
  DON: {
    label: "DONE",
    variant: "outline-success",
    tooltip: "Selesai"
  },
  REJ: {
    label: "REJECTED",
    variant: "outline-danger",
    tooltip: "Ditolak"
  }
}